import { render, staticRenderFns } from "./BankPreAccUploadItemsPanel.vue?vue&type=template&id=1c183692&scoped=true&"
import script from "./BankPreAccUploadItemsPanel.vue?vue&type=script&lang=ts&"
export * from "./BankPreAccUploadItemsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./BankPreAccUploadItemsPanel.vue?vue&type=style&index=0&id=1c183692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c183692",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VSpacer})
